import { useSchedulingLocationView } from 'app/components/scheduling-location-view/useSchedulingLocationView'
import { SchedulingLocationViewComponent } from 'app/components/scheduling-location-view/SchedulingLocationViewComponent'

export default function LocationView() {
  const { location, tabs, onToggleSchedulerLive, onCopyPreviewLink, onCopySchedulingLink } = useSchedulingLocationView()

  return (
    <SchedulingLocationViewComponent
      locationName={location?.name ?? ``}
      isSchedulerLive={location.isSchedulerLive}
      tabs={tabs}
      onToggleSchedulerLive={onToggleSchedulerLive}
      onCopyPreviewLink={onCopyPreviewLink}
      onCopySchedulingLink={onCopySchedulingLink}
    />
  )
}
